import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { Domain } from '~src/settings/bridge-settings/sections/types/Domain';

export type DeleteBridgePoolDialogProps = Readonly<{
  poolName: string;
  hasAgents: boolean;
  hasDomains: boolean;
  domains: Domain[];
}>

const dialogClass = style({ marginBottom: 30, whiteSpace: 'break-spaces' });
const listClass = style({ maxHeight: 100, overflowY: 'auto', overflowX: 'clip' });
const listItemClass = style({ listStyleType: 'none', paddingInlineStart: TabStyles.Spacing.LargeSpace });

export function DeleteBridgePoolDialogBody(props: DeleteBridgePoolDialogProps) {
  return (
    <div className={dialogClass}>
      <div>{getDeletePoolMessage(props)}</div>
      <div className={listClass}>
        {props.hasDomains &&
          <ul id='domainList' className={listItemClass}>
            {props.domains.map(domain => {
              return <li key={domain.domainName}>{domain.domainName}</li>;
            })}
          </ul>
        }
      </div>
    </div>
  );
}

function getDeletePoolMessage(props: DeleteBridgePoolDialogProps) {
  let message = Messages.bridgeSiteSettingsDeletePoolWarning({ POOL_NAME: L10n.elideIfLong(props.poolName) });
  if (props.hasAgents && props.hasDomains) {
    message += ' ' + Messages.bridgeSiteSettingsDeletePoolWithAgentsAndDomains();
  }
  else if (props.hasAgents) {
    message += ' ' + Messages.bridgeSiteSettingsDeletePoolWithAgents();
  }
  else if (props.hasDomains) {
    message += ' ' + Messages.bridgeSiteSettingsDeletePoolWithDomains();
  }
  return message;
}
